import { Grid, Typography } from "@material-ui/core";
import { Header, Privacy } from "modules/ui";
import React, { useEffect, useState } from "react";
import { StateContext } from "context/context";
import { db } from "firebase-app/config";
import { Navigation } from "../../navigation";
import styles from "./styles/contact.module.scss";

interface ContactType {
    contact: string;
}

const Contact = () => {
    const [contact, setContact] = useState<string>("");
    const { state } = StateContext();

    const getTerms = async () => {
        const ref = await db.collection("general").doc("event-detail").get();

        const data = ref.data() as ContactType;

        setContact(data?.contact);
    };

    useEffect(() => {
        getTerms();
    }, []);

    return (
        <>
            <Header background="#E1F2FF" logoColor="#522CA9" showContent={true} />
            {!state.privacyPermission && <Privacy />}
            <div className={styles.content}>
                <Navigation />
                <div className={styles.scroll}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography style={{ textAlign: "center" }} variant="h6">Contact and Support</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            {contact && <div dangerouslySetInnerHTML={{ __html: contact }} />}
                        </Grid>
                    </Grid>
                </div>
            </div>
        </>
    );
};

export default Contact;